export default __webpack_public_path__ + "static/media/favorites-spicy-barre.bf015ca9.png";